const production = {
  name: 'production',
  apiUrl: 'https://dev.octacode.ba:3030',
  audience: 'https://dev.octacode.ba:3030',
  domain: 'dev-vr3j7dxa.eu.auth0.com',
  clientId: 'AGSsCEwXYegt9xRkJ61ShN2xAolBHl4k'
}

export default production;